import PropTypes from 'prop-types'
import React from 'react'

import { Accordion, CircularFeature } from '../../../components'
import Feature from '../../../models/Feature'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function HomeFeatures(props) {
  const { features, t } = props

  const panels = features.map(feature => ({ label: feature.title.replace(/<\/br>/g, ""), content: feature.description }))

  return (
    <section className="features">
      <div className="features">
          {
            features.map(({ title, description, icon }) => (
              <CircularFeature
                key={title}
                icon={icon}
                title={title}
                text={description}
              />
            ))
          }
      </div>
      <Accordion panels={panels} />
      <style jsx>{styles}</style>
    </section>
  )
}

HomeFeatures.propTypes = {
  features: PropTypes.arrayOf(PropTypes.shape(Feature.props)).isRequired,
  t: PropTypes.any
}

HomeFeatures = chainDecorators(decorators, HomeFeatures)

export default HomeFeatures
